import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductSpecificationsComponent } from './product-specifications.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { GenericTableDoubleAttrsComponent } from './components/generic-table-double-attrs/generic-table-double-attrs.component';
import { GenericTableMultiCollumnsComponent } from './components/generic-table-multi-collumns/generic-table-multi-collumns.component';

@NgModule({
  declarations: [ProductSpecificationsComponent, GenericTableDoubleAttrsComponent, GenericTableMultiCollumnsComponent],
  imports: [CommonModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        TabSpecifications: {
          component: ProductSpecificationsComponent,
        },
      },
    }),
  ],
})
export class ProductSpecificationsModule {}